import { useTranslation } from 'react-i18next';
import { SystemBar } from '@c2fo/liquidity';
import SimulateClearDrawer from '@/demo/components/SimulateClearDrawer';
import { getActiveDemoName } from '@/demo/demoHandlers';

const DemoBanner = () => {
  const { t } = useTranslation();
  const baseMessage = t('demo.bannerMessage');
  const demoName = getActiveDemoName();
  const message = demoName ? `${baseMessage} · ${demoName}` : baseMessage;

  return (
    <div data-testid="demo-banner">
      <SystemBar variant="demo" label={message} action={<SimulateClearDrawer />} />
    </div>
  );
};

export default DemoBanner;
